// extracted by mini-css-extract-plugin
module.exports = {"subtitle":"MobileSubtitle_subtitle__1wajx"};